import type { ShopperProductsTypes } from 'commerce-sdk-isomorphic'

export type ProductAvailabilityModel = {
  isInStock: boolean
  isLowStock: boolean
  lowStockThreshold: number
  isBackOrder: boolean
  isPreOrder: boolean
  isReplenish: boolean
  inStockDate: string
  inStockAmount: number
}

export type ProductWithInventory = {
  inventory?: ShopperProductsTypes.Inventory
  isReplenished?: boolean
}

export const getProductAvailabilityModel = (
  product: ProductWithInventory,
  productStockLowThreshold: number,
): ProductAvailabilityModel => {
  const productAvailabilityModel = {
    isInStock: false,
    isLowStock: false,
    lowStockThreshold: 0,
    isBackOrder: false,
    isPreOrder: false,
    inStockDate: '',
    inStockAmount: 0,
    isReplenish: false,
  }

  if (!product) {
    return productAvailabilityModel
  }

  const { inventory } = product
  if (!inventory) {
    return productAvailabilityModel
  }
  const isStockAvailable = inventory.orderable
  productAvailabilityModel.lowStockThreshold = productStockLowThreshold

  const inStockDate = inventory?.inStockDate ? new Date(inventory.inStockDate) : null

  // Get stock level and stock date - the two are used across all inventory type
  if (inStockDate && inStockDate > new Date()) {
    productAvailabilityModel.inStockDate = inventory.inStockDate
  }

  if (inventory?.ats && inventory?.ats > 0) {
    productAvailabilityModel.inStockAmount = inventory.ats
  }

  // Get "In Stock" and "Low Stock level" stock type
  if (isStockAvailable && inventory?.ats) {
    if (inventory.ats > productAvailabilityModel.lowStockThreshold) {
      // There are stock and the stock level is greater than the low stock threshold
      productAvailabilityModel.isInStock = true
    } else if (inventory.ats > 0) {
      // There are stock and the stock level is lower or equal to low stock threshold but greater than 0
      productAvailabilityModel.isLowStock = true
    }
  }

  // Get "Out of Stock / Backorder" and "Preorder" stock type
  productAvailabilityModel.isBackOrder = inventory?.backorderable ?? false
  productAvailabilityModel.isPreOrder = inventory?.preorderable ?? false

  // Check for replenish flag
  productAvailabilityModel.isReplenish = product?.isReplenished ?? false

  return productAvailabilityModel
}
